import React from 'react'
import styles from "./AllDesigns.module.css"

import HomeSidebar from "../HomeSidebar/HomeSidebar"

export default function AllDesigns() {
  return (
    <section className={styles.allDesignsPage}>
      <HomeSidebar selectedOption={"allDesigns"} />

      <div className={styles.allDesignsContainer}>
        <h2>Coming Soon</h2>
      </div>
    </section>
  )
}
